/** Configuration templates: the list, the wizard and the blueprints it renders — English, the source of the other languages */
const templates = {
  "templates.title": "Templates",
  "templates.subtitle": "Reusable configuration for your sites",
  "templates.new": "New template",
  "templates.allTypes": "All types",
  "templates.empty": "No templates yet",
  "templates.emptyText": "Create a template by pulling the configuration from an existing site, or build one yourself.",
  "templates.createFirst": "Create the first template",
  "templates.family.ANY": "Any device",
  "templates.defaultBadge": "DEFAULT",
  "templates.origin.PULLED": "pulled",
  "templates.origin.MANUAL": "built",
  "templates.system": "System",
  "templates.applications": { one: "applied {count} time", other: "applied {count} times" },
  "templates.editHint": "Edit the template and its configuration",
  "templates.apply": "Apply",
  "templates.deleteNamed": "Delete {name}",
  "templates.deleteConfirm": "Delete template \"{name}\"?",
  "templates.applyTitle": "Apply template",
  "templates.queued": { one: "Queued for {count} site", other: "Queued for {count} sites" },
  "templates.queuedText": "Each site reports which fields were applied. Unsupported fields are recorded, not silently dropped.",
  "templates.done": "Done",
  "templates.targets": "\"{name}\" is for {family} devices.",
  "templates.noCompatible": "No connected site can take this template. Check the device family it is for.",
  "templates.partial": { one: "{count} chosen site will skip some fields:", other: "{count} chosen sites will skip some fields:" },
  "templates.more": "+{count} more",
  "templates.showIncompatible": { one: "Show {count} site that cannot take it", other: "Show {count} sites that cannot take it" },
  "templates.hideIncompatible": { one: "Hide {count} site that cannot take it", other: "Hide {count} sites that cannot take it" },
  "templates.notLicensed": "not in your licence",
  "templates.noSupported": "no supported fields",
  "templates.wrongFamily": "other device family",
  "templates.applyTo": { one: "Apply to {count} site", other: "Apply to {count} sites" },
  "templates.allSupported": "All fields supported",
  "templates.skipped": { one: "{count} field will be skipped", other: "{count} fields will be skipped" },
  "templates.family.UNIFI": "Controllers and Site Manager",
  "templates.family.VELANOX": "One Speed bonded WAN",
  "templates.family.TELTONIKA": "RutOS cellular routers",
  "templates.family.PEPLINK": "Balance / MAX with SpeedFusion",
  "templates.family.MIKROTIK": "RouterOS routers and PtP / PtMP radio links",
  "templates.saveFailed": "The template could not be saved",
  "templates.pullFailed": "The configuration could not be pulled",
  "templates.updated": "Template updated",
  "templates.saved": "Template saved",
  "templates.viewAll": "View templates",
  "templates.createAnother": "Create another",
  "templates.back": "Back",
  "templates.editing": "Edit: {name}",
  "templates.whichKind": "Which kind of device is this for?",
  "templates.sitesConnected": { one: "{count} site connected", other: "{count} sites connected" },
  "templates.named": "{name} template",
  "templates.whatConfigure": "What do you want to configure?",
  "templates.variant": "Target variant",
  "templates.variantHint": "Variants managed through the cloud support fewer changes than direct access to the device.",
  "templates.loadingTypes": "Loading template types…",
  "templates.howCreate": "How do you want to create it?",
  "templates.buildWizard": "Build with the wizard",
  "templates.buildHint": "Step by step, showing only what {family} devices support.",
  "templates.pullFromSite": "Pull from a site",
  "templates.noPullSites": "No UniFi controller sites connected yet.",
  "templates.pullOnlyFor": "Available for network, WiFi and WAN templates from a UniFi controller site.",
  "templates.pullFrom": { one: "Copy the live configuration from your UniFi controller site.", other: "Copy the live configuration from one of your {count} UniFi controller sites." },
  "templates.sourceSite": "Source site *",
  "templates.chooseSite": "Choose a site…",
  "templates.name": "Template name *",
  "templates.description": "Description",
  "templates.optional": "Optional",
  "templates.optionalParen": "(optional)",
  "templates.pullConfig": "Pull configuration",
  "templates.coverage": "{provider} supports {count} of {total} options for this template type.",
  "templates.hiddenSteps": { one: "{count} step is hidden entirely.", other: "{count} steps are hidden entirely." },
  "templates.stepOf": "Step {n} of {total}",
  "templates.nothingHere": "Nothing to configure on this step for {provider}.",
  "templates.showUnsupported": { one: "Show {count} unsupported option", other: "Show {count} unsupported options" },
  "templates.hideUnsupported": { one: "Hide {count} unsupported option", other: "Hide {count} unsupported options" },
  "templates.saveTemplate": "Save template",
  "templates.updateTemplate": "Update template",
  "templates.myName": "My {name}",
  "templates.useSuggestion": "Use \"{name}\"",
  "templates.next": "Next",
  "templates.notSupported": "not supported",
  "templates.enabled": "Enabled",
  "templates.disabled": "Disabled",
  "templates.choose": "Choose…",
  "templates.typeEnter": "Type and press Enter",
  "templates.add": "Add",
  "templates.removeNamed": "Remove {name}",
  "templates.inUse": "in use: {list}",
  "templates.type.NETWORK": "Network / VLAN",
  "templates.typeDesc.NETWORK": "VLAN segmentation, DHCP scope and isolation",
  "templates.step.NETWORK.identity": "Purpose & identity",
  "templates.stepDesc.NETWORK.identity": "What this network is for",
  "templates.field.NETWORK.purpose": "Purpose",
  "templates.option.NETWORK.purpose.production": "🏭 Production",
  "templates.option.NETWORK.purpose.cash-registers": "🏪 Cash registers",
  "templates.option.NETWORK.purpose.entrance": "🚪 Entrance / lobby",
  "templates.option.NETWORK.purpose.cp": "🖥️ CP / control panel",
  "templates.option.NETWORK.purpose.employers": "👔 Employers / staff",
  "templates.option.NETWORK.purpose.media": "📺 Media / AV",
  "templates.option.NETWORK.purpose.iot": "📡 IoT devices",
  "templates.option.NETWORK.purpose.guest": "🌐 Guest / visitor",
  "templates.option.NETWORK.purpose.vlan-only": "🔒 VLAN only (no DHCP)",
  "templates.field.NETWORK.name": "Network name",
  "templates.field.NETWORK.vlanId": "VLAN ID",
  "templates.help.NETWORK.vlanId": "Suggested from VLANs already used by your templates",
  "templates.step.NETWORK.addressing": "IP addressing & DHCP",
  "templates.stepDesc.NETWORK.addressing": "Subnet and address pool",
  "templates.field.NETWORK.subnet": "Subnet",
  "templates.help.NETWORK.subnet": "e.g. 192.168.30.0/24",
  "templates.field.NETWORK.dhcp.enabled": "DHCP server",
  "templates.field.NETWORK.dhcp.start": "DHCP start",
  "templates.field.NETWORK.dhcp.end": "DHCP end",
  "templates.field.NETWORK.dhcp.dns": "DNS servers",
  "templates.step.NETWORK.security": "Security",
  "templates.stepDesc.NETWORK.security": "Isolation and protection",
  "templates.field.NETWORK.isolation": "Client isolation",
  "templates.help.NETWORK.isolation": "Stops devices on this network talking to each other",
  "templates.field.NETWORK.dhcpGuard": "DHCP guard",
  "templates.help.NETWORK.dhcpGuard": "Blocks rogue DHCP servers",
  "templates.field.NETWORK.igmpSnooping": "IGMP snooping",
  "templates.type.WIFI": "WiFi network",
  "templates.typeDesc.WIFI": "SSID, security and radio behaviour",
  "templates.step.WIFI.identity": "SSID & identity",
  "templates.stepDesc.WIFI.identity": "Name and visibility",
  "templates.field.WIFI.ssid": "SSID",
  "templates.field.WIFI.enabled": "Network active",
  "templates.field.WIFI.isHidden": "Hidden SSID",
  "templates.field.WIFI.isGuest": "Guest network",
  "templates.help.WIFI.isGuest": "Isolates clients from the LAN",
  "templates.step.WIFI.security": "Security",
  "templates.stepDesc.WIFI.security": "Encryption and credentials",
  "templates.field.WIFI.security": "Security type",
  "templates.option.WIFI.security.wpa3": "WPA3 Personal (recommended)",
  "templates.option.WIFI.security.wpa2": "WPA2 Personal (compatible)",
  "templates.option.WIFI.security.wpa2-enterprise": "WPA2 Enterprise (RADIUS)",
  "templates.option.WIFI.security.open": "Open — no password",
  "templates.field.WIFI.passphrase": "Password",
  "templates.help.WIFI.passphrase": "Minimum 8 characters",
  "templates.field.WIFI.vlanId": "VLAN tag",
  "templates.help.WIFI.vlanId": "Blank leaves the SSID untagged",
  "templates.step.WIFI.radio": "Radio & performance",
  "templates.stepDesc.WIFI.radio": "Bands and roaming",
  "templates.field.WIFI.band": "Band",
  "templates.option.WIFI.band.both": "2.4 + 5 GHz",
  "templates.option.WIFI.band.5g": "5 GHz only",
  "templates.option.WIFI.band.2g": "2.4 GHz only",
  "templates.option.WIFI.band.6g": "6 GHz (WiFi 6E)",
  "templates.field.WIFI.txPower": "TX power",
  "templates.option.WIFI.txPower.auto": "Auto",
  "templates.option.WIFI.txPower.low": "Low",
  "templates.option.WIFI.txPower.medium": "Medium",
  "templates.option.WIFI.txPower.high": "High",
  "templates.field.WIFI.fastRoaming": "Fast roaming (802.11r)",
  "templates.field.WIFI.minRssi": "Minimum signal",
  "templates.field.WIFI.scheduleEnabled": "Schedule enabled",
  "templates.type.WAN": "WAN / Internet",
  "templates.typeDesc.WAN": "Uplink behaviour, failover and load balancing",
  "templates.step.WAN.links": "Uplink behaviour",
  "templates.stepDesc.WAN.links": "How the WAN links are used",
  "templates.field.WAN.failoverEnabled": "Failover",
  "templates.help.WAN.failoverEnabled": "Switch to a backup link when the primary fails",
  "templates.field.WAN.loadBalancingEnabled": "Load balancing",
  "templates.help.WAN.loadBalancingEnabled": "Spread sessions across active links",
  "templates.field.WAN.wanPortCount": "Number of WAN links",
  "templates.option.WAN.wanPortCount.2": "2",
  "templates.option.WAN.wanPortCount.3": "3",
  "templates.option.WAN.wanPortCount.4": "4",
  "templates.field.WAN.healthCheckEnabled": "Health check",
  "templates.help.WAN.healthCheckEnabled": "Probe each link and mark it down on failure",
  "templates.field.WAN.priorityMode": "Priority mode",
  "templates.option.WAN.priorityMode.ordered": "Strict order",
  "templates.option.WAN.priorityMode.weighted": "Weighted",
  "templates.step.WAN.quality": "Quality of service",
  "templates.stepDesc.WAN.quality": "Queue management and MTU",
  "templates.field.WAN.smartQueueEnabled": "Smart Queue (QoS)",
  "templates.help.WAN.smartQueueEnabled": "Reduces bufferbloat under load",
  "templates.field.WAN.smartQueueAutoDetect": "Auto-detect speed on deploy",
  "templates.help.WAN.smartQueueAutoDetect": "Runs a speed test when applied and uses 90% of the result",
  "templates.field.WAN.smartQueueDown": "Download speed",
  "templates.field.WAN.smartQueueUp": "Upload speed",
  "templates.field.WAN.mtu": "MTU",
  "templates.type.CELLULAR": "Cellular / SIM",
  "templates.typeDesc.CELLULAR": "APN, SIM policy, data caps and roaming",
  "templates.step.CELLULAR.carrier": "Carrier & APN",
  "templates.stepDesc.CELLULAR.carrier": "How the modem attaches to the network",
  "templates.field.CELLULAR.apn": "APN",
  "templates.help.CELLULAR.apn": "Leave blank for carrier auto-detection",
  "templates.field.CELLULAR.apnUser": "APN username",
  "templates.field.CELLULAR.apnPassword": "APN password",
  "templates.field.CELLULAR.pin": "SIM PIN",
  "templates.step.CELLULAR.sim": "SIM policy",
  "templates.stepDesc.CELLULAR.sim": "Which SIM is used and when to switch",
  "templates.field.CELLULAR.simSwitch": "Preferred SIM slot",
  "templates.option.CELLULAR.simSwitch.1": "SIM 1",
  "templates.option.CELLULAR.simSwitch.2": "SIM 2",
  "templates.field.CELLULAR.simFailover": "Auto-switch on failure",
  "templates.help.CELLULAR.simFailover": "Falls back to the other SIM if the connection drops",
  "templates.field.CELLULAR.roaming": "Allow roaming",
  "templates.help.CELLULAR.roaming": "Can be expensive outside the home network",
  "templates.step.CELLULAR.limits": "Data & radio",
  "templates.stepDesc.CELLULAR.limits": "Caps and band selection",
  "templates.field.CELLULAR.dataLimit": "Monthly data limit",
  "templates.help.CELLULAR.dataLimit": "An alert fires at 90% of this",
  "templates.field.CELLULAR.dataLimitAction": "When limit reached",
  "templates.option.CELLULAR.dataLimitAction.alert": "Alert only",
  "templates.option.CELLULAR.dataLimitAction.throttle": "Throttle",
  "templates.option.CELLULAR.dataLimitAction.disconnect": "Disconnect",
  "templates.field.CELLULAR.bandLock": "Band lock",
  "templates.help.CELLULAR.bandLock": "Comma-separated band numbers, blank = auto",
  "templates.field.CELLULAR.networkMode": "Network mode",
  "templates.option.CELLULAR.networkMode.auto": "Auto",
  "templates.option.CELLULAR.networkMode.5g": "5G preferred",
  "templates.option.CELLULAR.networkMode.lte": "LTE only",
  "templates.option.CELLULAR.networkMode.3g": "3G fallback",
  "templates.type.TUNNEL": "Tunnel / bonding",
  "templates.typeDesc.TUNNEL": "SpeedFusion bonding and VPN client profiles",
  "templates.step.TUNNEL.profile": "Tunnel profile",
  "templates.stepDesc.TUNNEL.profile": "Peer and bonding mode",
  "templates.field.TUNNEL.name": "Profile name",
  "templates.field.TUNNEL.peerHost": "Peer host",
  "templates.help.TUNNEL.peerHost": "Hostname or IP of the tunnel endpoint",
  "templates.field.TUNNEL.mode": "Mode",
  "templates.option.TUNNEL.mode.bonding": "Bonding — combine bandwidth",
  "templates.option.TUNNEL.mode.failover": "Failover — hot standby",
  "templates.option.TUNNEL.mode.overflow": "Overflow — spill to secondary",
  "templates.field.TUNNEL.encryption": "Encryption",
  "templates.option.TUNNEL.encryption.aes256": "AES-256",
  "templates.option.TUNNEL.encryption.aes128": "AES-128",
  "templates.option.TUNNEL.encryption.none": "None",
  "templates.step.TUNNEL.behaviour": "Behaviour",
  "templates.stepDesc.TUNNEL.behaviour": "Reconnection and VPN client",
  "templates.field.TUNNEL.autoReconnect": "Auto-reconnect",
  "templates.field.TUNNEL.vpnClientEnabled": "VPN client",
  "templates.field.TUNNEL.vpnClientConfig": "VPN profile",
  "templates.type.SYSTEM": "System baseline",
  "templates.typeDesc.SYSTEM": "Time, identity and firmware policy",
  "templates.step.SYSTEM.identity": "Identity & time",
  "templates.stepDesc.SYSTEM.identity": "Naming and clock",
  "templates.field.SYSTEM.hostname": "Hostname pattern",
  "templates.help.SYSTEM.hostname": "Use {site} to insert the site name",
  "templates.field.SYSTEM.timezone": "Timezone",
  "templates.field.SYSTEM.ntp": "NTP server",
  "templates.step.SYSTEM.maintenance": "Maintenance",
  "templates.stepDesc.SYSTEM.maintenance": "Firmware and backups",
  "templates.field.SYSTEM.firmwareCheck": "Check firmware on apply",
  "templates.field.SYSTEM.firmwareUpgrade": "Auto-install updates",
  "templates.help.SYSTEM.firmwareUpgrade": "Applies the latest build — causes a reboot",
  "templates.field.SYSTEM.backup": "Back up before changes",
  "templates.type.LINK": "Wireless link",
  "templates.typeDesc.LINK": "Point-to-point or point-to-multipoint radio settings — one template per side",
  "templates.step.LINK.role": "Role",
  "templates.stepDesc.LINK.role": "Which end of the link this device is",
  "templates.field.LINK.topology": "Topology",
  "templates.option.LINK.topology.ptp": "Point-to-point — one station",
  "templates.option.LINK.topology.ptmp": "Point-to-multipoint — several stations",
  "templates.field.LINK.role": "This side",
  "templates.help.LINK.role": "Apply the station template first, then the access point within 10 minutes — the other way round the stations lose the link. A station keeps its new settings once the access point matches; if it does not in time, it goes back by itself",
  "templates.option.LINK.role.ap": "Access point (the sector / the near end)",
  "templates.option.LINK.role.station": "Station (the CPE / the far end)",
  "templates.field.LINK.interface": "Radio interface",
  "templates.help.LINK.interface": "Blank picks the link radio when there is one (a station, a 60 GHz or NV2/Nstreme radio); a device with several radios needs the name (wlan60-1, wlan1, wifi1 …)",
  "templates.step.LINK.radio": "Radio",
  "templates.stepDesc.LINK.radio": "Both ends must match",
  "templates.field.LINK.ssid": "Link name (SSID)",
  "templates.field.LINK.linkKey": "Link key",
  "templates.help.LINK.linkKey": "At least 8 characters. NV2 key, WPA2/WPA3 passphrase or 60 GHz password, depending on the radio",
  "templates.field.LINK.frequency": "Frequency",
  "templates.help.LINK.frequency": "5 GHz e.g. 5500. 60 GHz: 58320, 60480, 62640, 64800 or 66000. Blank keeps the current one",
  "templates.field.LINK.channelWidth": "Channel width",
  "templates.help.LINK.channelWidth": "Not used on 60 GHz",
  "templates.option.LINK.channelWidth.20": "20 MHz",
  "templates.option.LINK.channelWidth.40": "40 MHz",
  "templates.option.LINK.channelWidth.80": "80 MHz",
  "templates.field.LINK.protocol": "Protocol",
  "templates.help.LINK.protocol": "Only the 2.4/5 GHz \"wireless\" driver; WiFi 6 radios always use 802.11",
  "templates.option.LINK.protocol.nv2": "NV2 (MikroTik TDMA — best for outdoor links)",
  "templates.option.LINK.protocol.802.11": "802.11 (standard WiFi)",
  "templates.option.LINK.protocol.nstreme": "Nstreme",
  "templates.option.LINK.protocol.any": "Any (follow the access point)",
  "templates.field.LINK.txPower": "TX power",
  "templates.help.LINK.txPower": "Blank keeps the current setting. Stay within the limit of your regulatory domain",
  "templates.type.CYBERSECURE": "CyberSecure",
  "templates.typeDesc.CYBERSECURE": "IPS, content filtering and threat management",
  "templates.step.CYBERSECURE.ips": "Intrusion prevention",
  "templates.stepDesc.CYBERSECURE.ips": "Signature-based blocking",
  "templates.field.CYBERSECURE.ips.enabled": "Enable IPS/IDS",
  "templates.field.CYBERSECURE.ips.mode": "Mode",
  "templates.option.CYBERSECURE.ips.mode.ips": "IPS — block threats",
  "templates.option.CYBERSECURE.ips.mode.ids": "IDS — alert only",
  "templates.step.CYBERSECURE.content": "Content filtering",
  "templates.stepDesc.CYBERSECURE.content": "Category and domain blocking",
  "templates.field.CYBERSECURE.contentFilter.enabled": "Enable content filtering",
  "templates.field.CYBERSECURE.contentFilter.categories": "Blocked categories",
  "templates.option.CYBERSECURE.contentFilter.categories.adult": "🔞 Adult",
  "templates.option.CYBERSECURE.contentFilter.categories.gambling": "🎰 Gambling",
  "templates.option.CYBERSECURE.contentFilter.categories.malware": "🦠 Malware",
  "templates.option.CYBERSECURE.contentFilter.categories.p2p": "⬇️ P2P",
  "templates.option.CYBERSECURE.contentFilter.categories.ads": "📢 Ads",
  "templates.option.CYBERSECURE.contentFilter.categories.social": "💬 Social",
  "templates.option.CYBERSECURE.contentFilter.categories.streaming": "📺 Streaming",
  "templates.option.CYBERSECURE.contentFilter.categories.games": "🎮 Gaming",
  "templates.field.CYBERSECURE.contentFilter.customBlockedUrls": "Custom blocked domains",
  "templates.help.CYBERSECURE.contentFilter.customBlockedUrls": "Add domains one at a time",
  "templates.type.COMPANY_DEFAULTS": "Company defaults",
  "templates.typeDesc.COMPANY_DEFAULTS": "A bundle of templates applied to every new site",
  "templates.step.COMPANY_DEFAULTS.bundle": "Included templates",
  "templates.stepDesc.COMPANY_DEFAULTS.bundle": "Applied in order when a site comes online",
  "templates.field.COMPANY_DEFAULTS.networkTemplateIds": "Network templates",
  "templates.field.COMPANY_DEFAULTS.wifiTemplateIds": "WiFi templates",
  "templates.field.COMPANY_DEFAULTS.wanTemplateId": "WAN template",
  "templates.field.COMPANY_DEFAULTS.cellularTemplateId": "Cellular template",
  "templates.field.COMPANY_DEFAULTS.tunnelTemplateId": "Tunnel template",
  "templates.field.COMPANY_DEFAULTS.systemTemplateId": "System template",
}

export default templates
